<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-6 text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t("plan.title") }}</span>
        <h3 class="page-title">{{ $t("plan.sub") }}</h3>
      </div>
    </div>
    <!-- Pricing Box -->
    <PricingBox :showPricingTitle="false" />
  </d-container>
</template>

<script>
import PricingBox from "@/components/common/PricingBox.vue";

export default {
  components: {
    PricingBox: PricingBox
  },
  data() {
    return {};
  }
};
</script>

<style lang="css" scoped>
</style>